import { render } from "./Confindustria.vue?vue&type=template&id=7ec3881e&scoped=true&ts=true"
import script from "./Confindustria.vue?vue&type=script&lang=ts"
export * from "./Confindustria.vue?vue&type=script&lang=ts"

import "./Confindustria.vue?vue&type=style&index=0&id=7ec3881e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec3881e"]])

export default __exports__